import { render } from "./singleBranch.vue?vue&type=template&id=ef9a7e16&scoped=true"
import script from "./singleBranch.vue?vue&type=script&lang=js"
export * from "./singleBranch.vue?vue&type=script&lang=js"

import "./singleBranch.vue?vue&type=style&index=0&id=ef9a7e16&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef9a7e16"]])

export default __exports__